import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  menuChangeBehaviour,
  menuChangeBreakpoints,
  menuChangePinButtonEnable,
  menuChangePlacement,
  menuChangeUseSidebar,
  menuResetBreakpoints,
  menuResetUseSidebar,
} from 'layout/nav/main-menu/menuSlice';
import { settingsChangeColor, settingsChangeLayout, settingsChangeNavColor, settingsChangeRadius, settingsResetLayout } from 'settings/settingsSlice';
import { IReduxState } from 'ReduxState';

interface ICustomLayout {
  placement?: string | null | undefined;
  behaviour?: string | null | undefined;
  layout?: string | null | undefined;
  radius?: number | null | undefined;
  color?: string | null | undefined;
  navColor?: string | null | undefined;
  useSidebar?: boolean | null | undefined
  pinEnable?: boolean | null | undefined;
  fullpage?: boolean | null | undefined;
  breakpoints?: any;
  homelayout?: string | null | undefined;
  usertype?: string | null | undefined;
}


const useCustomLayout = ({
  placement = null,
  behaviour = null,
  layout = null,
  radius = null,
  color = null,
  navColor = null,
  useSidebar = null,
  pinEnable = null,
  fullpage = null,
  breakpoints = null,
  homelayout = null,
  usertype = null,
}: ICustomLayout) => {
  const dispatch = useDispatch();
  const {
    placement: currentPlacement,
    behaviour: currentBehaviour,
    breakpoints: currentBreakpoints,
    pinButtonEnable: currentPinButtonEnable,
    useSidebar: currentUseSidebar,
  } = useSelector((state: IReduxState) => state.menu);
  const { layout: currentLayout, radius: currentRadius, color: currentColor, navColor: currentNavColor } = useSelector((state: IReduxState) => state.settings);
  const variables = {
    placement: placement || currentPlacement,
    behaviour: behaviour || currentBehaviour,
    layout: layout || currentLayout,
    radius: radius || currentRadius,
    color: color || currentColor,
    navColor: navColor || currentNavColor,
    breakpoints: breakpoints || currentBreakpoints,
    useSidebar: useSidebar || currentUseSidebar,
  };
  useEffect(() => {
    const changes = {
      placement: false,
      behaviour: false,
      layout: false,
      radius: false,
      color: false,
      navColor: false,
      breakpoints: false,
      pinEnable: false,
      useSidebar: false,
      fullpage: false,
      homelayout: false,
    };

    if (placement) {
      changes.placement = true;
      dispatch(menuChangePlacement(placement));
    }

    if (behaviour) {
      changes.behaviour = true;
      dispatch(menuChangeBehaviour(behaviour));
    }

    if (layout) {
      changes.layout = true;
      dispatch(settingsChangeLayout(layout));
    }
    if (radius) {
      changes.radius = true;
      dispatch(settingsChangeRadius(radius));
    }

    if (color) {
      changes.color = true;
      dispatch(settingsChangeColor(color));
    }
    if (navColor) {
      changes.navColor = true;
      dispatch(settingsChangeNavColor(navColor));
    }

    if (breakpoints) {
      changes.breakpoints = true;
      dispatch(menuChangeBreakpoints(breakpoints));
    }

    if (pinEnable !== null) {
      changes.pinEnable = true;
      dispatch(menuChangePinButtonEnable(pinEnable));
    }

    if (useSidebar !== null) {
      changes.useSidebar = true;
      dispatch(menuChangeUseSidebar(useSidebar));
    }
    if (fullpage !== null) {
      changes.fullpage = true;
      document.documentElement.setAttribute('data-fullpage', String(fullpage));
    }
    if (homelayout != null) {
      changes.homelayout = true;
      document.documentElement.setAttribute('data-home', String(homelayout));
    }

    return () => {
      if (changes.placement) dispatch(menuChangePlacement(currentPlacement));
      if (changes.behaviour) dispatch(menuChangeBehaviour(currentBehaviour));
      if (changes.layout) dispatch(settingsResetLayout());
      if (changes.radius) dispatch(settingsChangeRadius(currentRadius));
      if (changes.color) dispatch(settingsChangeColor(currentColor));
      if (changes.navColor) dispatch(settingsChangeNavColor(currentNavColor));
      if (changes.breakpoints) dispatch(menuResetBreakpoints());
      if (changes.pinEnable) dispatch(menuChangePinButtonEnable(currentPinButtonEnable));
      if (changes.useSidebar) dispatch(menuResetUseSidebar());
      if (changes.fullpage) document.documentElement.removeAttribute('data-fullpage');
      if (changes.homelayout) document.documentElement.removeAttribute('data-homelayout');
    };
    // eslint-disable-next-line
  }, []);

  return variables;
};

export default useCustomLayout;
